import React from 'react';
import { ExternalLink, Layers } from 'lucide-react';

/**
 * Hub di consultazione: elenca tutti i widget di sistema con la sezione admin
 * dove modificarne i contenuti. Cliccando una riga si apre la sezione corretta.
 */
export default function WidgetSistemaHub({ onNavigate }) {
  const widgets = [
    { key: 'home', label: 'Hero homepage / Logo / Patrocini', section: 'home', desc: 'Contenuti del banner principale, logo, slogan, patrocini.' },
    { key: 'home-finale', label: 'Banner "Serata Finale"', section: 'finale', desc: 'Etichetta, data, stadio, programma serata di chiusura.' },
    { key: 'concorso', label: 'Concorso di Disegno', section: 'concorso', desc: 'Titolo, descrizione, dettagli, data premiazione, icona.' },
    { key: 'brochure', label: 'Brochure (homepage)', section: 'brochure', desc: 'Pagine, riordino, etichette, PDF completo, titolo sezione.' },
    { key: 'campi', label: 'Campi da gioco (mappa)', section: 'home', desc: 'Lista campi, indirizzi, link mappa.' },
    { key: 'sponsor', label: 'Sponsor', section: 'sponsor', desc: 'Logo + nome + sito web di ogni sponsor.' },
    { key: 'partners', label: 'Partner', section: 'partner', desc: 'Sezioni, ordine, partner per sezione, link.' },
    { key: 'squadre', label: 'Squadre partecipanti', section: 'squadre', desc: 'Categoria, anno, città, presidente, allenatore, descrizione, foto.' },
    { key: 'calendario', label: 'Calendario partite', section: 'calendario', desc: 'Giornate, eventi, orari, luoghi, etichetta, categoria.' },
    { key: 'classifiche', label: 'Classifiche & Risultati', section: 'classifiche', desc: 'Categorie ranking + risultati partite (sincronizzato col calendario).' },
    { key: 'regolamento', label: 'Regolamento', section: 'regolamento', desc: 'Articoli con titolo + testo, ordine, eliminazione.' },
    { key: 'galleria', label: 'Galleria foto', section: 'galleria', desc: 'Foto della galleria, titoli, categorie, multi-upload.' },
    { key: 'video', label: 'Video', section: 'video', desc: 'Embed YouTube/Vimeo, titolo, descrizione.' },
    { key: 'edizioni', label: 'Edizioni Passate', section: 'edizioni', desc: 'Anno, descrizione, vincitori, gallery foto edizione.' },
    { key: 'chi-siamo', label: 'Chi Siamo / Comitato / Si Ringrazia', section: 'chisiamo', desc: 'Paragrafi, missione cards, comitato organizzatore, ringraziamenti formattati.' },
    { key: 'contatti', label: 'Contatti', section: 'contatti', desc: 'Indirizzi, telefoni, email, social, mappa.' },
    { key: 'testi', label: 'Testi del sito (header/footer/menu)', section: 'testi', desc: 'Tutte le diciture statiche: navigazione, footer, label.' },
    { key: 'tema', label: 'Tema / Colori globali', section: 'tema', desc: 'Palette colori, font, sfondo.' },
    { key: 'media', label: 'Libreria Media', section: 'media', desc: 'Tutti i file caricati (immagini, video, PDF).' },
    { key: 'pagine', label: 'Pagine dinamiche', section: 'pages', desc: 'Costruisci pagine custom con widget drag&drop.' },
    { key: 'layout', label: 'Layout pagine sistema', section: 'layout', desc: 'Riorganizza l\'ordine dei widget di sistema in ogni pagina (drag&drop).' },
  ];

  return (
    <div className="space-y-3" data-testid="widget-hub">
      <div className="glass-card p-5">
        <h2 className="text-white font-bold text-lg flex items-center gap-2 mb-2"><Layers size={20} className="text-pink-brand" /> Dove modificare ogni widget</h2>
        <p className="text-white/70 text-sm">
          Ogni widget visibile sul sito legge le informazioni da una sezione amministrativa specifica. Clicca un widget qui sotto per essere portato direttamente nell'editor giusto.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        {widgets.map((w) => (
          <button
            key={w.key}
            onClick={() => onNavigate?.(w.section)}
            className="text-left bg-navy-dark/70 border border-white/10 hover:border-pink-brand rounded-lg p-4 transition-colors group"
            data-testid={`hub-${w.key}`}
          >
            <div className="flex items-start gap-3">
              <div className="flex-1 min-w-0">
                <div className="text-white font-bold text-sm mb-1 flex items-center gap-1.5">
                  {w.label}
                  <ExternalLink size={12} className="text-pink-brand opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <div className="text-white/60 text-xs leading-relaxed">{w.desc}</div>
                <div className="text-pink-brand text-[10px] uppercase tracking-widest font-bold mt-2">→ Apri sezione</div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
